export default __webpack_public_path__ + "static/media/AUTORES_DISCO_05.312d9efd.png";